export default function(state = {}, action) {
  const typeMap = {
    BEST_WORKPLACES_PAGE_LOADING() {
      return {
        isLoading: true,
        bestWorkplacesPage: action.bestWorkplacesPage
      };
    },
    BEST_WORKPLACES_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.bestWorkplacesPage
      };
    },
    BEST_WORKPLACES_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.bestWorkplacesPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
